<div class="risk-menu">
  <a *ngFor="let menuItem of filteredMenuItems; let i = index; trackBy: trackByFn" [ngClass]="getActiveClass(menuItem)"
    [routerLink]="menuItem.path" [routerLinkActiveOptions]="{ exact: isFirstItem(i) }" routerLinkActive="active"
     (click)="onTabSelected(menuItem.description)">
    <div class="risk-menu__tab">
      <div class="risk-menu__tab--header">{{menuItem.description}}</div>
      <div *ngIf="menuItem.extra.showBadge" class="badge">{{menuItem.extra.count}}</div>
    </div>
  </a>
</div>